/** Selector for any instance of this _Friendation_ component */
const selector = '[is="block-faq-search"]';

/**
 * Friendation component
 */
export const blockFaqSearch = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    const handleSearch = () => {
      const form: HTMLFormElement = component.querySelector('form');
      const searchInput: HTMLInputElement = form.querySelector('input');
      const submitButton: HTMLButtonElement = form.querySelector('button');
      const resultsContainer: HTMLElement = component.querySelector('.results');
      const noResultsMessage: HTMLElement =
        component.querySelector('.noResults');
      const results: HTMLElement[] = Array.from(
        component.querySelectorAll('.panel')
      );
      let firstSearch = true;

      let oldValue;

      const onSubmit = (e: SubmitEvent) => {
        e.preventDefault();

        const url = new URL(window.location.href);
        url.searchParams.set(searchInput.name, searchInput.value);
        window.history.pushState({}, '', url.href);

        if (!searchInput.value.length) {
          return;
        }

        if (searchInput.value === oldValue) {
          return;
        }

        oldValue = searchInput.value;
        update();
      };

      const onInput = () => {
        submitButton.disabled = !form.checkValidity();
      };

      form.addEventListener('submit', onSubmit);
      searchInput.addEventListener('input', onInput);

      const update = () => {
        form.setAttribute('aria-busy', 'true');
        searchInput.disabled = true;

        /** First search... */
        if (firstSearch) {
          results.forEach((result) => {
            result.classList.remove(
              'animation',
              'animation--delay-started',
              'animation--started',
              'animation--fadeInUpSoft'
            );
          });

          const textAboveSearchResults = component.querySelector(
            '[is="block-accordion"] > .text'
          );
          if (textAboveSearchResults) textAboveSearchResults.remove();
        } else {
          firstSearch = false;
        }

        /** Second and other searches... */

        results.forEach((result) => {
          /** User search term */
          const searchTerm = searchInput.value.trim().toLowerCase();

          /** Text to compare with {@link searchTerm} */
          const textValue = result.innerText.trim().toLowerCase();

          const match = textValue.includes(searchTerm);

          if (match) {
            /** Show result because {@link searchTerm} is in {@link textValue} */
            result.inert = false;
          } else {
            /** Hide result, because it is no {@link match} */
            result.inert = true;
          }
        });

        /** Show no results message when no results are found */
        if (!results.find((x) => !x.inert)) {
          /** no results found */
          noResultsMessage.inert = false;
          resultsContainer.inert = true;

          setTimeout(() => {
            noResultsMessage.tabIndex = -1;
            noResultsMessage.focus();
          }, 100);
        } else {
          /** results found */
          noResultsMessage.inert = true;
          resultsContainer.inert = false;

          setTimeout(() => {
            const firstResult = results
              .find((x) => !x.inert)
              .querySelector('button');
            if (firstResult) firstResult.focus();
          }, 100);
        }

        setTimeout(() => {
          form.removeAttribute('aria-busy');
          searchInput.disabled = false;
        }, 1000);
      };
    };

    handleSearch();
  });
};
